import React, { Component } from "react"
import { searchTableFilter } from "../Tree/Utils.js"

import SearchBar from '../Tree/components/SearchBar.jsx'
//import { EditableCell } from '../TableList/EditableCell'
import { ProductRow } from '../TableList/ProductRow'
// input (props) 
//      tableTitle={"תוכנית עבודה"}
//      familyCode - TBD
// Resources: see import above

// TODO: get data from DB && Update to DB

export const  Diploma_microLegend = {
    "education_qualification": "הכשרה/תעודה",
    "education_hours": "שעות",
    "education_qual_inst": "מוסד/גוף לימודי",
    "education_qual_title": "תואר/תעודה",
    "education_qual_year": "שנה"
}

export class ParentDiploma extends Component {

    constructor(props) {
      super(props)
      this.state = { products: this.props.data }
      this.onSaveTable = this.onSaveTable.bind(this)
    }
    
    handleRowDel(product) {
      const {products} = this.state
      var index = products.indexOf(product)
      if (index === -1)
        return console.log("FamilyRights productnot found", product)

      var array = [...products]
      //this.state.products.splice(index, 1)
      array.splice(index, 1)
      this.setState({products:array})
    }
  
    handleAddEvent(evt) {
      evt.preventDefault()
      var id = (+ new Date() + Math.floor(Math.random() * 999999)).toString(36);
      //let d = digmaDate(Date())
      var product = {
        id: id,
        education_qualification: "",
        education_hours: "",
        education_qual_inst: "",
        education_qual_title: "",
        education_qual_year: ""
      } 

      let newP = (this.state.products === undefined || this.state.products === false) ? [] : Object.assign(this.state.products)
      newP.unshift(product)
      this.setState({products: newP})
    }
  
    handleProductTable(evt) {
      evt.preventDefault()

      var item = {
        //id: evt.target.id,
        name: evt.target.name,
        value: evt.target.value,
        nid: evt.target.getAttribute('data-id')
    }
        // console.log("pRODUCT-EVT", item);

        var products = this.state.products.slice();
        // console.log("products-EVT", products);

        var newProducts = products.map(function(product) {
  
            for (var key in product) {
                if (key === item.name && product.id === item.nid) {
                    product[key] = item.value
                }
            }
            return product
        })
        this.setState({products:newProducts})
    }

    // update data base
    onSaveTable(evt) {
      evt.preventDefault()
      const { save2DB, subTableId, memberPostId } = this.props
      //console.log("Family General save table: products", this.state.products)
      //console.log("Parent Diploma props: ", this.props)
   
      save2DB(memberPostId, this.state.products, subTableId, "table" )
    }
    render() {
      const {tableTitle} = this.props
      // const { data } = this.props
      // console.log("Family general data", data)
      //console.log("OLD meeting data", this.state.products)
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable.bind(this)}
            onSaveTable={this.onSaveTable}    
            headerColumns = {["education_qualification","education_hours", "education_qual_inst", "education_qual_title", "education_qual_year"]}
            tableTitle = {tableTitle} // "סיכומי מפגשים"
            onRowAdd={this.handleAddEvent.bind(this)} 
            onRowDel={this.handleRowDel.bind(this)} 
            products={this.state.products} 
          />
      )
    }
  }
  /*   class SearchBar extends Component { moved to file */
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : ""
        }
        this.handleUserInput = this.handleUserInput.bind(this)
    }
    
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() {
      const { onProductTableUpdate, onRowDel, onRowAdd, headerColumns, products, tableTitle, onSaveTable } = this.props
      var filterText = this.state.filterText;
     /* const yahavModalHalf = { maxHeight: '45vh',  maxWidth:'100%', paddingRight:'20px',right: '160px', bottom: 'auto',
                             left: 'calc(90vw-200px)', overflow: 'visible', overflowY: 'scroll', overflowX: 'hidden'} */
      
      var product = (products === undefined || products === false) ? "" : products.map(function(product) {
          // check on all relevant data fields
          if (!searchTableFilter(product, filterText))
                return null;
       var rowKey=0  
       const cellData=[{
        type: "text",
        name: "education_qualification",
        value: product.education_qualification,
        id: product.id,
        style: {width: "180px"},
        edit: true
      },{
        type: "text",
        name: "education_hours",
        value: product.education_hours,
        id: product.id,
        style: {width: "80px"},
        edit: true
      },{
        type: "text",
        name: "education_qual_inst",
        value: product.education_qual_inst,
        id: product.id,
        style: {width: "180px"},
        edit: true
      },{
        type: "text",
        name: "education_qual_title",
        value: product.education_qual_title,
        id: product.id,
        style: {width: "180px"},
        edit: true
      },{
        type: "text",
        name: "education_qual_year",
        value: product.education_qual_year,
        id: product.id,
        style: {width: "90px"},
        edit: true
      }] 
      
       
        return (
          <ProductRow 
            onProductTableUpdate={onProductTableUpdate} 
            product={product} 
            onDelEvent={onRowDel.bind(this)} 
            key={product.id || rowKey++}
            cd={cellData}
            />)
      })

      return table_box_element(tableTitle, products, product, onRowAdd, this.state.filterText, 
                            this.handleUserInput, onSaveTable, headerColumns, Diploma_microLegend)

    }
  }
  
  export const table_box_element = (tableTitle, products, product, onRowAdd, filterText, handleUserInput, onSaveTable, headerColumns, microLegend) =>{
    var thStyle = { fontSize: '15px',color:'#333', fontWeight: 'bold'}
    var buttonStyle = {marginRight: '0'}
    var searchbarStyle = {margin: '5px 10px'}
    return (
      <div className="sub-tab">
        <h2 style={{textAlign: 'center'}}>{tableTitle}&nbsp;(סה"כ&nbsp;{(products === undefined) ? 0 : products.length})</h2>
        <button style={buttonStyle} type="button" onClick={onRowAdd} className="btn btn-success pull-right">הוספת שורה</button>
        <button style={buttonStyle} type="button"  className="btn btn-success pull-left update-button" onClick={onSaveTable}>עדכון</button>
        <SearchBar style={searchbarStyle} filterText={filterText} onUserInput={handleUserInput} />
        <table className="table table-box-element">
            <thead>
                <tr >
                {headerColumns.map (col => { 
                  return(<th style={thStyle} key={col}>{microLegend[col]?microLegend[col] : col}</th>) 
              }) } 
                </tr>
            </thead>  
            <tbody>
                {products !== undefined ? product : null}
            </tbody>
        </table>
      </div>
    )
  }
  

 